<section class="responsive-card d-flex flex-column gap-4">
  <div class="d-flex flex-column gap-2">
    <h3 i18n class="responsive-card-title">Current Recurring Payments</h3>
    <div *ngIf="paidInMonth$ | async as paidInMonth" class="paid-info">
      <span i18n>Paid in {{ paidInMonth }}</span>
    </div>
  </div>
  <ul class="no-style-list d-flex flex-column gap-3">
    <ng-container *ngFor="let row of rows$ | async; let last = last">
      <li class="d-flex align-items-center justify-content-between gap-4">
        <div class="flex-grow-1">
          <span class="paragraph-lg" *ngIf="row.governingJurisdictionId">{{
            row.governingJurisdictionId | governingJurisdictionName
          }}</span>
          <span class="paragraph-lg" *ngIf="!row.governingJurisdictionId" i18n>Non-Locked-In</span>
        </div>
        <div class="d-flex flex-column align-items-end gap-1">
          <div class="label-sm">{{ row.paymentAmount | currency }} {{ row.frequencyLabel }}</div>
          <div class="payment-type">{{ row.amountTypeLabel }}</div>
        </div>
      </li>
      <hr class="m-0" />
    </ng-container>
  </ul>
  <div class="d-flex justify-content-between align-items-center gap-4">
    <div class="label-sm" i18n>Estimated Recurring Payments Total:</div>
    <div class="label-sm text-nowrap">{{ total$ | async | currency }} {{ frequencyLabel$ | async }}</div>
  </div>
</section>
